import api from './config/api';
import axios from './config/axios';

export default {
    // Attempt to login a user with the given credentials
    login( { username, password } ) {
        return axios( {
            url: api.logisticsUrl( 'account/login' ),
            method: 'post',
            data: {
                userName: username,
                password,
            },
        } );
    },

    // Request a token to reset the user's password
    // Step 1 of 3
    passwordResetRequest( { websiteId, email } ) {
        const url = `${ window.location.origin }/reset-password?token={token}`;
        return axios( {
            url: `${ api.API_BASE_URL }/app-rest/portal/v1/${ websiteId }/customer/password/requestReset`,
            method: 'post',
            params: {
                email,
                url,
            },
        } );
    },

    // Validate a password reset token
    // Step 2 of 3
    validatePasswordResetToken( { websiteId, token } ) {
        return axios( {
            url: `${ api.API_BASE_URL }/app-rest/portal/v1/${ websiteId }/customer/password/validateResetToken`,
            method: 'get',
            params: {
                token,
            },
        } );
    },

    // Reset the user's password
    // Step 3 of 3
    resetPassword( { websiteId, token, password } ) {
        return axios( {
            url: `${ api.API_BASE_URL }/app-rest/portal/v1/${ websiteId }/customer/password/resetPassword`,
            method: 'put',
            params: {
                token,
                newPassword: password,
            },
        } );
    },
};
